class VariationInformation {
    constructor() {
        // set this.materials and this.formats
        this.readProductPropertiesFromDOM();

        // set this.variations
        this.readVariationsFromDOM();

    }

    /**
     * Return an array of available materials. Each material contains the following keys
     *  - title
     *  - subtitle
     *  - price
     *  - image
     *  - optionId
     */
    getMaterials() {
        let result = [];
        let translations = JSON.parse(document.getElementById('json-material-translations').innerText);

        this.materials.forEach((material) => {
            let name = material.translated.name;

            result.push({
                title: translations[`material.${name}.title`] || name,
                subtitle: translations[`material.${name}.subtitle`] || '',
                productCode: translations[`material.${name}.productCode`] || '',
                price: this.getCheapestVariationPrice([material.id]),
                image: (material.media && material.media.url) ? material.media.url : '',
                optionId: material.id,
                position: material.translated.position ?? 0,
            });
        });

        result.sort((a, b) =>  a.position - b.position);

        return result;
    }


    /**
     * Read information about material + format from DOM.
     * The DOM should look like the following:
     *
     <script type="x-template" id="json-product-properties">
     [
     {
        "id": "75f353b589d04bf48e8a9ab1f5422b0e"
        "name": "Format",
        "displayType": "text",
        "sortingType": "alphanumeric",
        "description": null,
        "position": 1,
        "filterable": true,
        "options": [
            {
                "groupId": "75f353b589d04bf48e8a9ab1f5422b0e",
                "name": "40x30",
                "position": 1,
                "colorHexCode": null,
                "mediaId": null,
                "group": null,
                "translations": null,
                "productConfiguratorSettings": null,
                "productProperties": null,
                "productOptions": null,
                "media": null,
                "customFields": null,
                "_uniqueIdentifier": "5c1947d6dbb24be1834e10b6a81d105d",
                "versionId": null,
                "translated": {
                    "name": "40x30",
                    "position": 1,
                    "customFields": []
                },
                "createdAt": "2021-01-29T14:01:10.757+00:00",
                "updatedAt": null,
                "extensions": {
                    "foreignKeys": {
                        "apiAlias": null,
                        "extensions": []
                    }
                },
                "id": "5c1947d6dbb24be1834e10b6a81d105d"
            }
        ],
        "translations": null,
        "customFields": null,
        "_uniqueIdentifier": "75f353b589d04bf48e8a9ab1f5422b0e",
        "versionId": null,
        "translated": {
            "name": "Format",
            "description": null,
            "position": 1,
            "customFields": []
        },
        "createdAt": "2020-12-15T12:02:11.301+00:00",
        "updatedAt": "2021-02-03T10:42:18.666+00:00",
        "extensions": {
            "internal_mapping_storage": {
                "apiAlias": null,
                "extensions": []
            },
            "foreignKeys": {
                "apiAlias": null,
                "extensions": []
            }
        },
    }
     */
    readProductPropertiesFromDOM() {
        let properties = document.getElementById('json-product-properties');
        if(!properties) {
            alert('Größe und Format können nicht korrekt geladen werden. Bitte wenden Sie sich an uns.');
            return;
        }

        properties = JSON.parse(properties.innerText);

        properties.forEach((property) => {
            // for material: fill options with id when title matches
            if(property.name === 'Material' || (property.translated && property.translated.name === 'Material')) {
                this.materialPropertyId = property.id;
                this.materialPropertyId = property.options[0].groupId;
                this.materials = property.options;
            }
            else if(property.name === 'Format' || (property.translated && property.translated.name === 'Format')) {
                this.formatPropertyId = property.id;
                this.formatPropertyId = property.options[0].groupId;
                this.formats = property.options;
            }
        });
    }

    /**
     * Read information about variations from DOM. The DOM should look like this:
     *   <script type="x-template" id="json-variations">
     [
         {
            "productNumber": "SW10002.54",
            "options": [
                "32a671ebf467461cb80aee1bdbbada26",
                "c36d68be7cc043c98c78375891eac40a"
            ],
            "price": null
        },
         {
            "productNumber": "SW10002.27",
            "options": [
                "947d115bc7ef4470a5fb085c07afbc10",
                "96638a1c7ab847bbb3ca64167ab30a3e"
            ],
            "price": [
            {
                "currencyId": "b7d2554b0ce847cd82f3ac9bd1c0dfca",
                "net": 100,
                "gross": 100,
                "linked": true,
                "listPrice": null,
                "extensions": []
            }
        ]
        },
         ...
     ]
     </script>
     */
    readVariationsFromDOM() {
        let variations = document.getElementById('json-variations');
        if(!variations) {
            alert('Die verfügbaren Produktvariationen können nicht korrekt geladen werden. Bitte wenden Sie sich an uns.');
            return;
        }

        this.variations = JSON.parse(variations.innerText);
    }

    /**
     * Return the name of the radio input that is used for selecting materials
     * @return {*}
     */
    getMaterialRadioInputName() {
        return this.materialPropertyId;
    }

    /**
     * Return the name of the radio input that is used for selecting format.
     * @return {*}
     */
    getFormatRadioInputName() {
        return this.formatPropertyId;
    }

    /**
     * Return the id of the material option with the given name.
     * => getMaterialOptionId('Acryl Glas')  returns 'c53fa30db00e4a84b4516f6b07c02e8d'
     *
     * @param optionName
     * @return {*}
     */
    getMaterialOptionId(optionName) {
        for(let idx in this.materials) {
            if(!this.materials.hasOwnProperty(idx)) {
                continue;
            }

            let name = this.materials[idx].name ?? this.materials[idx].translated.name;
            if(name === optionName) {
                return this.materials[idx].id;
            }
        }
    }

    /**
     * Get the id of the format option with the given name. Format names have to be "{width}x{height}",
     * for example "100x70"
     * @param string widthXheight
     * @param id
     */
    getFormatOptionId(widthXheight, id) {
        widthXheight.split('x');

        for(let idx in this.formats) {
            if(!this.formats.hasOwnProperty(idx)) {
                continue;
            }

            let format = this.formats[idx];
            let name = format.name ?? format.translated.name;
            if(name === widthXheight) {
                return format.id;
            }
        }
    }

    /**
     * Return the cheapest possible price from variations with the selected option ids.
     * @param selectedOptions
     */
    getCheapestVariationPrice(selectedOptions) {
        // convert single option to array
        if(typeof selectedOptions === 'string') {
            selectedOptions = [selectedOptions];
        }

        // the minimum price for the selected options
        let minPrice = null;

        this.variations.forEach((variation) => {
            let hasOption = (optionId) => variation.options.indexOf(optionId) > -1;
            let hasAllOptions = selectedOptions.every(hasOption);

            if(hasAllOptions) {
                if(!variation.price) {
                    minPrice = 0;
                }
                else {
                    let price = variation.price[0].gross;

                    if(minPrice === null || price < minPrice) {
                        minPrice = price;
                    }
                }


            }
        });

        return minPrice;
    }

    getFormats(ratio) {
        ratio = parseFloat(ratio).toPrecision(3);

        let result = [];
        let intSort = (a, b) => {
            return parseFloat(a) > parseFloat(b) ? 1 : -1;
        };

        this.formats.forEach((format) => {
            let name = format.name ?? format.translated.name;
            // use sort() in the end so WIDTH is always the bigger one
            let [height, width] = name.split('x').sort(intSort);
            let formatRatio = parseFloat(width / height).toPrecision(3);

            if(ratio === formatRatio) {
                result.push(format);
            }
        })

        return result;
    }
}

export default new VariationInformation();
